import { createContext } from 'react'

import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'

interface IReactWidgetContext {
  widgetId: string
  widgetParams: Record<string, any>
  widgetWidth: number
  widgetFlexWidth: FlexDirectionBreak
  widgetFullWidth: boolean
  widgetCustomSettings: Record<string, any>
  widgetIsFullScreen: boolean
}

export const ReactWidgetContext = createContext<IReactWidgetContext>({
  widgetId: '',
  widgetParams: {},
  widgetWidth: 0,
  widgetFlexWidth: FlexDirectionBreak.p112,
  widgetFullWidth: false,
  widgetCustomSettings: {},
  widgetIsFullScreen: false,
})
